import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';
import '../styles/ElevationChart.css';

const ElevationChart = ({ coordinates, distances }) => {
  const chartData = coordinates.map((coord, index) => ({
    distance: distances ? (distances[index] / 1000).toFixed(2) : index * 0.01,
    elevation: coord.elevation,
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label"><strong>KM:</strong> {payload[0].payload.distance}</p>
          <p className="value"><strong>Altitud:</strong> {payload[0].value.toFixed(0)}m</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="elevation-chart-container fade-in">
      <h3 className="chart-title">Perfil d'Elevació</h3>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="elevationGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#667eea" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#764ba2" stopOpacity={0.2} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
          <XAxis dataKey="distance" label={{ value: 'Distància (km)', position: 'insideBottom', offset: -5 }} stroke="#666" />
          <YAxis label={{ value: 'Altitud (m)', angle: -90, position: 'insideLeft' }} stroke="#666" />
          <Tooltip content={<CustomTooltip />} />
          <Area type="monotone" dataKey="elevation" stroke="#667eea" strokeWidth={3} fill="url(#elevationGradient)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ElevationChart;